import React from "react";

const Footer = () => {
  return <div className="py-4 text-center bg-secondery text-white ">
    <p>Thank you for visiting my place.</p>
  
  </div>;
};

export default Footer;
